import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: 'https://smartcampus-east-api.jimoos.cn/v1/gateway',
  timeout: 10000 // 请求超时时间
})


// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
  }
  return Promise.reject(error.response.data)
}
// request interceptor
request.interceptors.request.use((config) => {
    config.headers['x-client-id'] = 'default'
    config.headers['x-tenant-id'] = 0
    config.headers.Authorization = 'smartCampus-server MDo1SmhocnJSVWZKdUxwV21vbzRrcWJ4V1FqRkZ0eVFPYQ=='
  return config
}, errorHandler)

export default request

export { request as axios }

